module.exports = __webpack_public_path__ + "media/images/product-img-04-7f4ba4f437d36d45c829b42f4bf82206.jpeg";